// File: cgp-authentication.js
// Author: Brandon Shreve
// Date: 1/9/2017
// Desc: Authentication module that handles integrating with CGP Authentication.
//       Handles redirecting to GAME login page and reading the cookie that has our authorization token.
//       Has methods to get the authorization token as well as the logged in user's information.
// Other Contributors: Joseph M Diaz

import { config } from '../config/config';
import { cgpCookieHelper } from './cgp-cookie-helper';
import { cgpSecurityUrls, cgpLoginUrls } from '../../src/config/config.base';
import { getEnv } from './utility';


function singleSignOnRedirect(redirectLink: Location) {
    console.log(getEnv());
    const cgpSecurityUrl = cgpLoginUrls[getEnv()];
    window.location.replace(cgpSecurityUrl + redirectLink);
}

function updateMescLoading(msg) {
    const loadingTextElement = document.getElementById('loading');
    const loadingSymbolElement = document.getElementById('loading-spinner');

    loadingTextElement.lastElementChild.innerHTML = msg;
    loadingSymbolElement.style.display = 'none';
}

function validateToken(callback: Function) {
    const token = getAuthToken();

    if (token) {
        const url = cgpSecurityUrls[getEnv()] + 'validateToken';
        const http = new XMLHttpRequest();

        http.open('POST', url, true);
        http.setRequestHeader('Content-type', 'application/json');
        http.setRequestHeader('Authorization', token);

        http.onreadystatechange = function () {
            if (http.readyState !== XMLHttpRequest.DONE) {
                return;
            }

            if (http.status === 200) {
                const newToken = http.getResponseHeader(config.authentication.authenticationCookie);
                cgpCookieHelper.setAuthCookie(newToken.replace(/^\s*Bearer\s*/, ''));
                if (callback) { callback(); }
            } else {
                console.log("Validate Token SSO Redirect due to failed validation");
                singleSignOnRedirect(document.location);
            }
        };
        http.send();
    } else {
        console.log("NO TOKEN DURING VALIDATE TOKEN CALL");
        singleSignOnRedirect(document.location);
    }
}

function refreshToken(callback: Function) {
    const token = getAuthToken();
    const url = cgpSecurityUrls[getEnv()] + 'validateToken';
    const http = new XMLHttpRequest();

    http.open('POST', url, true);
    http.setRequestHeader('Content-type', 'application/json');
    http.setRequestHeader('Authorization', token);

    http.onreadystatechange = function () {
        if (http.readyState !== XMLHttpRequest.DONE) {
            return;
        }

        if (http.status === 200) {
            const newToken = http.getResponseHeader(config.authentication.authenticationCookie);
            cgpCookieHelper.setAuthCookie(newToken.replace(/^\s*Bearer\s*/, ''));
            if (callback) { callback(null, 'success'); }
        } else {
            if (callback) { callback('error', null); }
        }
    };
    http.send();
}

function invalidateToken(callback: Function) {
    // TODO: Uncomment code once CGP Services implements invalidateToken method
    //

    // const token = getAuthToken();
    // const url = config.authentication.authenticationBaseUrl + 'inValidateToken';
    // const http = new XMLHttpRequest();
    //
    // http.open('POST', url, true);
    // http.setRequestHeader('Content-type', 'application/json');
    // http.setRequestHeader('Authorization', token);
    //
    // http.onreadystatechange = function() {
    //     if (http.readyState !== XMLHttpRequest.DONE) {
    //         return;
    //     }
    //
    //     if (http.status === 200) {
    //         if (callback) { callback(null, 'success'); }
    //     }
    //     else {
    //         if (callback) { callback('error', null); }
    //     }
    // };
    // http.send();
    cgpCookieHelper.deleteAuthCookie();
}

function parseToken(token) {
    if (token) {
        const parsedToken = token.replace('Bearer_', 'Bearer ');
        return parsedToken;
    } else {
        return '';
    }
}

function getAuthToken() {
    const token = cgpCookieHelper.retrieveCookie(config.authentication.authenticationCookie);
    return parseToken(token);
}

function getUserInfo() {
    const userInfo = cgpCookieHelper.retrieveCookie(config.authentication.userInfoCookie);

    if (userInfo) {
        return JSON.parse(JSON.parse(userInfo));
    }

    return null;
}

export const cgpAuthentication = {
    singleSignOnRedirect: singleSignOnRedirect,
    getAuthToken: getAuthToken,
    getUserInfo: getUserInfo,
    validateToken: validateToken,
    invalidateToken: invalidateToken,
    refreshToken: refreshToken,
    updateMescLoading: updateMescLoading,
};